import React, { useMemo } from 'react';
import { DBO_V } from '@op/utils/format';
import TableMiniChart from '@opm/components/TableMiniChart';

interface IMemeTrendCellProps {
  record: any;
  tabKey: 'views' | 'likes';
  intl: (id: string) => string;
}

function MemeTrendCell({ record, tabKey, intl }: IMemeTrendCellProps) {
  const { timeline, data } = useMemo(() => {
    const { video_stats: stats } = record || {};
    const timeline = stats?.timeline || [];
    const { timeline_of_time } = stats || {};

    return {
      timeline,
      data: {
        timeline,
        timeline_of_start_time:
          timeline_of_time?.timeline_of_start_time || timeline?.[0]?.time,
        timeline_of_end_time:
          timeline_of_time?.timeline_of_end_time ||
          timeline?.[timeline?.length - 1]?.time,
      },
    };
  }, [record]);

  if (!timeline || timeline.length <= 1) return null;

  return (
    <div className="dbom-meme-trend-cell">
      <TableMiniChart
        name={tabKey === 'views' ? intl('Views') : intl('Likes')}
        className="dbom-meme-minichart"
        data={data}
        valueFormat={(val) => DBO_V.reviews(val)}
        height={70}
        filterEmptyValue={false}
        timeFormat='daily'
      />
    </div>
  );
}

export default React.memo(MemeTrendCell);
